import { Illustration, Text } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";
import { PhoneField } from "@src/appV2/lib/FormFields/PhoneField/PhoneField";
import { Button } from "@src/appV2/redesign/components/Button";
import { LoadingButton } from "@src/appV2/redesign/components/LoadingButton";
import { useFormContext } from "react-hook-form";

import { RecruiterScreeningWarningCallout } from "./RecruiterScreeningWarningCallout";

const MODAL_STACK_SPACING = 10;

export interface PhoneFormData {
  phone: string;
}

interface PhoneConfirmationStepContentProps {
  onConfirm: (data: PhoneFormData) => void;
  onBack: () => void;
  isNotifyingRecruiter: boolean;
  isScreenFirst: boolean;
  source: "banner" | "detail-cta";
}

function getTitle(params: { source: "banner" | "detail-cta"; isScreenFirst: boolean }): string {
  const { source, isScreenFirst } = params;

  if (source === "banner") {
    return "Complete call with Clipboard to apply for jobs";
  }

  return isScreenFirst
    ? "Complete call with Clipboard to unlock interviews"
    : "Complete call with Clipboard to book interview";
}

export function PhoneConfirmationStepContent(props: PhoneConfirmationStepContentProps) {
  const { onConfirm, onBack, isNotifyingRecruiter, isScreenFirst, source } = props;
  const { handleSubmit } = useFormContext<PhoneFormData>();

  const title = getTitle({ source, isScreenFirst });

  return (
    <Stack spacing={MODAL_STACK_SPACING} alignItems="center" justifyContent="center">
      <Stack spacing={4} alignItems="center" justifyContent="center">
        <Illustration type="phone" />

        <Text variant="h2" textAlign="center">
          {title}
        </Text>
      </Stack>

      <Stack spacing={4} alignSelf="stretch">
        <PhoneField name="phone" showLabel={false} />
      </Stack>

      {source !== "banner" && (
        <Stack justifyContent="flex-end" alignItems="center">
          <RecruiterScreeningWarningCallout />
        </Stack>
      )}

      <Stack spacing={4} alignSelf="stretch">
        <LoadingButton
          fullWidth
          variant="contained"
          size="large"
          isLoading={isNotifyingRecruiter}
          onClick={handleSubmit(onConfirm)}
        >
          Confirm call
        </LoadingButton>

        <Button fullWidth variant="outlined" size="large" onClick={onBack}>
          Back
        </Button>
      </Stack>
    </Stack>
  );
}
